import { render, staticRenderFns } from "./TransportDashboard.vue?vue&type=template&id=699185de&scoped=true&"
import script from "./TransportDashboard.vue?vue&type=script&lang=js&"
export * from "./TransportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TransportDashboard.vue?vue&type=style&index=0&id=699185de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699185de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VDivider,VSkeletonLoader,VSnackbar})
